import {ISerializable} from 'cerialize';

export const UrlTransformer: ISerializable = {
  Serialize(value: URL): string {
    if (value) {
      return value.toString();
    }
    return null;
  },
  Deserialize(value: string): URL {
    if (value) {
      return new URL(value);
    }
    return null;
  }
};
